import type { Action } from 'react-sweet-state';
import { errorFlags, useFlagsService } from '@atlassian/jira-flags';
import type { State } from '../../types';

export const showGenericErrorFlag = (): Action<State> => () => {
	const { showFlag } = useFlagsService();
	showFlag(errorFlags.genericError());
};
